<template lang="pug">
v-layout
  //- LOADER PROCESS
  v-dialog(v-model="loader.flag" persistent width="300")
    v-card(color="primary" dark="")
      v-card-text
        | {{loader.text}}
        v-progress-linear.mb-0(indeterminate="" color="white")
  v-dialog(v-model="openPopup" fullscreen hide-overlay persistent transition='dialog-bottom-transition')
    v-card.box-card-documentos-formatter
      v-toolbar(dark color='primary')
        v-btn.btn-backspace(outline flat fab small @click="methodClosePopup")
          v-icon keyboard_backspace
        v-toolbar-title
          span(style="color: #ffffff; font-size: 20px;") Documentos de endoso
      v-card-text.box-card-text-documentos(style="padding: 2em 1em;")
        v-layout(column align-center)
          v-flex.mb-4.mx-3
            span(style="color: #454A6C;font-size:18px;line-height:18px") Selecciona y descarga tus documentos.
          v-flex
            v-layout(row wrap style="width: 24em;")
              CardDocumentoEndoso(
                v-for="documento in documentos" :key="documento.id"
                style="margin-top: 10px !important;"
                @cardMethod="descargarDocumento(documento)"
                :text="documento.filename"
                :icon="iconDocumentoPdf"
                :icon2="iconDocumentoPdf"
              )
      v-card-actions
        v-layout(column align-center)
          v-flex
            span(style="font-size: 18px;color: #0855C4;" @click="methodClosePopup")
              b Volver
</template>

<script>
import CardDocumentoEndoso from './CardDocumentoEndoso.vue'
import { mapActions } from 'vuex'

export default {
  props: [
    'openPopup',
    'taggeo',
    'id',
    'documentos'
  ],
  data () {
    return {
      iconDocumentoPdf: require('./../../assets/icons-mis-seguros/icon-pdf-documento-endoso.svg'),
      loader: {
        flag: false,
        text: ''
      },
      solicitudes: [],
      metadata: {}
    }
  },
  methods: {
    ...mapActions('event', ['eventLog']),
    ...mapActions('endorsements', ['downloadPdfEndorsement']),
    descargarDocumento (documento) {
      const self = this
      self.loader.flag = true
      self.loader.text = 'Descargando documento...'
      self.downloadPdfEndorsement({
        reqId: documento.requirement_id,
        docId: documento.id,
        state: documento.state,
        filename: documento.url_file
      }).then(res => {
        self.loader.flag = false
        setTimeout(() => {
          self.$root.$emit('showNps', {
            nombre: 'NPS - Inicio de Encuesta',
            funcionalidad: 'Descarga de documentos de endoso',
            metadata: self.metadata
          })
        }, 3000)
      }).catch(err => {
        self.loader.flag = false
        setTimeout(() => {
          self.$root.$emit('showNps', {
            nombre: 'NPS - Inicio de Encuesta',
            funcionalidad: 'Descarga de documentos de endoso',
            metadata: { ...self.metadata, error: err }
          })
        }, 3000)
      })
    },
    methodClosePopup () {
      this.$emit('closePopup', '')
    }
  },
  mounted () {
    let self = this
    self.metadata = {
      numeroPoliza: self.taggeo.numeroPoliza,
      antiguedad: self.taggeo.antiguedad,
      productoConsultado: self.taggeo.ramo,
      subproductoConsultado: self.taggeo.nombreProducto
    }
    self.$root.$emit('npsInactivity', {seccion: 'Mis seguros - Plan - Documentos de endoso'})

    self.eventLog({
      'tipoDocumento': self.taggeo.tipoDocumento,
      'numeroDocumento': self.taggeo.numeroDocumento,
      'categoria': 'Consulta',
      'nombre': self.taggeo.nombre,
      'datos': {
        'numeroPoliza': self.taggeo.numeroPoliza,
        'antiguedad': self.taggeo.antiguedad,
        'grupoProducto': self.taggeo.ramo,
        'producto': self.taggeo.nombreProducto,
        'navegacion': 'Plan',
        'dispositivo': 'desktop',
        'seccion': 'documentos de endoso'
      }
    })
  },
  components: {
    CardDocumentoEndoso
  }

}
</script>

<style scoped>
.box-tarjetas-documentos {
  max-width: fit-content;
  margin: 0.5em 0.5em;
}

@media (min-width : 600px) {
  .box-card-documentos-formatter .box-card-text-documentos {
    width: 35em;
    height: 41em;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mis-seguros/PopupDocumentosEndoso.vue